
import { createMetaReducer, createMiddleware } from 'redux-beacon';

import { eventsMap } from './gtm';
import {
  AccountEvent,
  CartEvent,
  CheckoutEvent,
  LicensingEvent,
  SearchEvent,
} from './types';

/****************************************************************************
 * For Facebook Pixel, we re-use GTM's event map as there isn't much to gain
 * from redefining a new map to intercept exactly the same redux actions
 * and, additionally, the data and event structure produced by GTM's event
 * handlers are easy to translate to FBQ events.
 *
 * Therefore, FBQ events received here are in the form of
 * { event, action, label, category, ecommerce }.
 ****************************************************************************/

function processFbq(events: any[]) {
  // tslint:disable-next-line:no-string-literal
  if (!window['fbq']) {
    return;
  }
  events.forEach((event) => {
    switch (event.event) {
      case AccountEvent.NewAccount:
        fbq('track', 'CompleteRegistration', {
          content_name: event.event,
        });
        break;
      case SearchEvent.Search:
        fbq('track', 'Search', {
          search_string: event.label,
        });
        break;
      case LicensingEvent.SetLicense:
        fbq('trackCustom', 'SetLicense', {
          license: event.label,
        } as any);
        break;
      case CartEvent.AddToCart:
        const product = event.ecommerce.add.products[0];
        fbq('track', 'AddToCart', {
          content_type: 'product',
          content_ids: [product.id],
          contents: [{
            id: product.id,
            quantity: 1,
            item_price: product.price,
            title: product.name,
            artist: product.brand,
            license: product.variant,
          }],
          currency: event.ecommerce.currencyCode,
          value: product.price,
        } as any);
        break;
      case CheckoutEvent.Checkout:
        fbq('track', 'InitiateCheckout');
        break;
      case CheckoutEvent.PlaceOrder:
        const products = event.ecommerce.purchase.products;
        fbq('track', 'Purchase', {
          content_ids: products.map((p) => p.id),
          content_type: 'product',
          contents: products.map((p) => ({
            id: p.id,
            quantity: p.quantity,
            item_price: p.price,
            title: p.name,
            artist: p.brand,
            license: p.variant,
          })),
          currency: event.ecommerce.currencyCode,
          num_items: products.length,
          value: event.ecommerce.purchase.actionField.revenue,
        } as any);
        break;
    }
  });
}

export const fbqMiddleware = createMiddleware(eventsMap, processFbq);
export const fbqMetaReducer = createMetaReducer(eventsMap, processFbq);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/analytics/fbq.ts